'use strict';

$(() => {
    /**
     * init image carousel
     */
    function initImageCarousel() {
        $('.cart-tile-images').each(function () {
            var $this = $(this);
            if (!$this.hasClass('slick-initialized')) {
                $this.slick({
                    dots: true,
                    lazyLoad: 'ondemand',
                    arrows: true,
                    infinite: false,
                    speed: 500,
                    touchThreshold: 100,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    nextArrow: '<button type="button" class="slick-next"><i class="icon icon-arrow-right-icon"></i></button>',
                    prevArrow: '<button type="button" class="slick-prev"><i class="icon icon-arrow-left-icon"></i></button>',
                });
            }
        });
    }

    /**
     * init slick carousel
     * @param {*} $context - carousel element
     */
    function initCarousel($context) {
        if (!$context.is('.slick-initialized, .product-carousel-loading, .product-carousel-disabled')) {
            var $container = $context.closest('.product-carousel-container');
            var containerData = $container && $container.data();
            var slidesToShowDesktop = (containerData && containerData.slides.desktop) || 6;
            var slidesToShowTablet = (containerData && containerData.slides.tablet) || 3;
            var slidesToShowMobile = (containerData && containerData.slides.mobile) || 1;
            var slickDots = (containerData && containerData.slickDots) || false;
            var slickArrows = (containerData && containerData.slickArrows) || false;
            var infiniteSlides = (containerData && containerData.slickInfinite) || false;
            var variableWidth = (containerData && containerData.variableWidth) || false;

            if ($container.hasClass('brand-dun')) {
                slickArrows = true;
            }

            if ($container.hasClass('brand-chl') && $container.closest('.suggestions').length) {
                slickDots = true;
            }

            setTimeout(() => {
                $context.hide();
                if ($container.width() > 0) {
                    $container.css('max-width', $container.outerWidth() + 'px');
                }
                $context.show();
            }, 0);

            if ($container.hasClass('brand-mtb')) {
                slickDots = true;
            }

            const slickSettings = {
                dots: slickDots,
                arrows: slickArrows,
                infinite: infiniteSlides,
                speed: 500,
                adaptiveHeight: true,
                variableWidth: variableWidth,
                touchThreshold: 100,
                slidesToShow: slidesToShowDesktop,
                slidesToScroll: 1,
                nextArrow: '<button type="button" class="slick-next"><i class="icon icon-arrow-right-hover icon-size-xl"></i></button>',
                prevArrow: '<button type="button" class="slick-prev"><i class="icon icon-arrow-left-hover icon-size-xl"></i></button>',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: slidesToShowTablet,
                            slidesToScroll: 1,
                            dots: slickDots,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: slidesToShowMobile,
                            slidesToScroll: 1,
                            dots: slickDots,
                        },
                    },
                ],
            };

            $context.slick(slickSettings);
        }
        initImageCarousel();

        const $textSlides = $context.find('.text-slider');
        const $firstImg = $context.find('.tile-image, .product-tile-component-image').first();
        if ($textSlides.length && $firstImg.length) {
            if ($firstImg[0].complete) {
                $textSlides.height($firstImg.height());
            } else {
                $firstImg.on('load', function () {
                    $textSlides.height($firstImg.height());
                });
            }
        }
    }

    $('.product-carousel').each(function () {
        initCarousel($(this));
    });

    $(document).on('initProductCarousel', function (e, data) {
        $(data.element).each(function () {
            initCarousel($(this));
        });
    });

    const observer = new MutationObserver(function (mutations) {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes && mutation.addedNodes.length > 0) {
                const addedNodes = $(mutation.addedNodes);
                for (let i = 0, len = addedNodes.length; i < len; i++) {
                    if ($(addedNodes[i]).hasClass('product-carousel')) {
                        initCarousel($(addedNodes[i]));
                    }
                }
            }
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    $(document).on('click', '.cart-tile-images .slick-arrow', function (e) {
        e.preventDefault();
    });

    initImageCarousel();
});
